import { render } from "./SnekChooser.vue?vue&type=template&id=d675ef0c"
import script from "./SnekChooser.vue?vue&type=script&lang=js"
export * from "./SnekChooser.vue?vue&type=script&lang=js"

import "./SnekChooser.vue?vue&type=style&index=0&id=d675ef0c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__